import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router'
import { EventCell } from '../../../../common/news/EventCell'
import { Table } from '../../../../common/table'
import { TextEllipsisStaticLine } from '../../../../common/textEllipsis/TextEllipsisStaticLine'
import { COMPONENTS } from '../../../../routers/constants'
import { INDUSTRY_NEWS_TYPE_ID, SCHEMA } from './constant'
import { Sentiment } from './Sentiment'
import {
  resetStore,
  selectIds,
  selectIsLoading,
  selectRecentNewsItem,
} from './store/slice'
import { getRecentNewsTable } from './store/thunk'

const TableContent = () => {
  const dispatch = useDispatch()
  const location = useLocation()

  const ids = useSelector(selectIds)
  const isLoading = useSelector(selectIsLoading)
  const locale = useSelector((state) => state.i18n.locale)
  const params = new Proxy(new URLSearchParams(location.search), {
    get: (searchParam, prop) => searchParam.get(prop),
  })

  useEffect(() => {
    dispatch(
      getRecentNewsTable({
        OrganizationId: params.organizationId,
        Page: 1,
        PageSize: 10,
      }),
    )
  }, [locale, params.organizationId])

  useEffect(() => {
    return () => {
      dispatch(resetStore())
    }
  }, [])

  const onRowClick = (rowId) => {
    window.open(
      [
        COMPONENTS.companyAnalysis.components.newsAndSocials.route,
        `?organizationId=${params.organizationId}`,
        `&newsTypeId=${INDUSTRY_NEWS_TYPE_ID}`,
        `&newsId=${rowId}`,
      ].join(''),
      '_blank',
    )
  }

  return (
    <Table
      getDataFromRedux={selectRecentNewsItem}
      ids={ids}
      isLoading={isLoading}
      isStickyFirstCol
      onRowClick={onRowClick}
      schema={Object.values(SCHEMA).map((item) => {
        return {
          title: item.label,
          colId: item.key,
          isI18n: true,
          render: (val, { locale, rowId }) => {
            switch (item.key) {
              case SCHEMA.SENTIMENT.key:
                return <Sentiment item={item} val={val} rowId={rowId} />

              case SCHEMA.HEADLINE.key:
                return (
                  <TextEllipsisStaticLine
                    isI18n={false}
                    text={item.format(val)}
                    lineClamp={1}
                  />
                )

              case SCHEMA.EVENT.key:
                return <EventCell val={val} />

              default:
                return item.format(val, locale)
            }
          },
        }
      })}
    />
  )
}

export default TableContent
